"use client";

import React from "react";
import Image from "next/image";
import { Container, Row, Col } from "react-bootstrap";
import styles from "./AcrSecuritySolutions.module.css";

interface CardItem {
  icon: string;
  title: string;
  desc: string;
}

interface Props {
  heading?: string;
  description?: string;
  theme?: "light" | "dark";
  cards: CardItem[];
}

const AcrSecuritySolutions: React.FC<Props> = ({
  heading = "Comprehensive Website Security Solutions",
  description,
  theme = "dark",
  cards,
}) => {
  return (
    <section className={`${styles.wrapper} ${styles[theme]}`}>
      <Container>
        {/* Heading */}
        <h2 className={styles.heading}>{heading}</h2>

        {/* Optional Description */}
        {description && <p className={styles.topDesc}>{description}</p>}

        <Row>
          {cards.map((item, index) => (
            <Col lg={4} md={6} sm={6} xs={12} className="mb-4" key={index}>
              <div className={styles.card}>
                <div className={styles.iconBox}>
                  <Image
                    src={item.icon}
                    alt={item.title}
                    width={26}
                    height={26}
                  />
                </div>

                <h4 className={`${styles.title} my-3`}>{item.title}</h4>
                <p className={styles.desc}>{item.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default AcrSecuritySolutions;
